var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alert"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2836",
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "!",
    d: "M8.96502 5.71429L11.2236 5.71429L10.8472 11.2636H9.34145L8.96502 5.71429ZM10.0943 14.3114C9.7624 14.3114 9.48311 14.2062 9.25645 13.9957C9.03787 13.7772 8.92859 13.5141 8.92859 13.2064C8.92859 12.8988 9.03787 12.6438 9.25645 12.4414C9.47502 12.231 9.7543 12.1257 10.0943 12.1257C10.4343 12.1257 10.7136 12.231 10.9322 12.4414C11.1507 12.6438 11.26 12.8988 11.26 13.2064C11.26 13.5141 11.1467 13.7772 10.92 13.9957C10.7014 14.2062 10.4262 14.3114 10.0943 14.3114Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlert);
export default __webpack_public_path__ + "static/media/ic-alert.1a4bbc7259038e04f10c51375bb991c4.svg";
export { ForwardRef as ReactComponent };